export default __webpack_public_path__ + "static/media/avatar.cc1b90cb.svg";